import { useId } from 'react';
import clsx from 'clsx';
import { Smartphone } from '@/components/icons';
import { phoneOptionLabel, profileOptionLabel, type RunDeviceState } from '@/lib/runDevice';
import { Select } from '@/components/ui';

/**
 * "Device: Pixel 9 · Android 16" choice next to Run buttons of Android projects: emulator profiles of the runners and
 * phones on Device Agents. Hidden until there is something to choose.
 */
export function RunDevicePicker({ state, className }: { state: RunDeviceState; className?: string }) {
  const id = useId();
  if (!state.enabled || (state.profiles.length === 0 && state.phones.length === 0)) return null;
  return (
    <div className={clsx('inline-flex items-center gap-2 text-sm', className)} title="Which kind of device runs use">
      <label htmlFor={id} className="inline-flex items-center gap-1.5 text-xs font-medium tracking-label whitespace-nowrap text-fg-secondary uppercase">
        <Smartphone className="size-3 text-primary" aria-hidden /> Device
      </label>
      <Select
        id={id}
        value={state.deviceProfile ?? ''}
        onChange={(e) => state.setDeviceProfile(e.target.value || null)}
        options={state.profiles.length ? [{ value: '', label: 'Any emulator' }] : []}
        groups={[
          { label: 'Emulators', options: state.profiles.map((p) => ({ value: p.id, label: profileOptionLabel(p) })) },
          { label: 'Connected phones', options: state.phones.map(({ agent, device }) => ({ value: device.profile, label: phoneOptionLabel(agent, device) })) },
        ]}
        className="w-56 max-w-full"
      />
    </div>
  );
}
